import type { SerializableObject } from '@frameio/utils';
import { ReactiveMap } from '../../../utils/ReactiveMap';

/* construct a key for the templates ReactiveMap */
export const getTemplateKey = (layout: string) => `template-${layout}`;

/*
 * Templates store user changed dimensions and/or configurations of
 * a layout (panel) at the page or component level depending on the key name.
 */
export const state = {
  /** @client fields store the last template positions with getTemplateKey */
  templates: new ReactiveMap<string, SerializableObject, 'templateStates'>(
    'templateStates'
  ),
};
